<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> 複製醫師 </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeCopy">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex row wrap xs12 sm12 md6 >
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >員工編號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>
                            <!--:disabled="this.editIndex!=-1"-->
                            <v-text-field   v-model="copyEmpNo"  @keyup.enter="NextItem('copyDivNo')"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex row wrap xs12 sm12 md6 >
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >科別代號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>
                            <v-autocomplete
                                    ref="copyDivNo"
                                    v-model="copyDivNo"
                                    hide-details
                                    :items="divNoList"
                                    :item-text="divItemText"
                                    item-value="divNo"
                            ></v-autocomplete>
                        </v-flex>
                    </v-flex>

                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeCopy">取消</v-btn>
            <v-btn  @click.native="confirmCopy">確定</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "SearchCopyDoctor",
        props:['divNoList'],
        data() {
            return {
                copyEmpNo: '',
                copyDivNo:'',
            }
        },
        methods:{
            divItemText: item => item.divNo==''?'':item.divNo + '-' + item.divName, //格式化 autocomplete 選權限顯示文字
            NextItem:function(id) {
                this.$refs[id].focus();
            },
            closeCopy(){
                this.$emit('closeCopy');
            },
            confirmCopy(){
                this.$emit('confirmCopy',this.copyEmpNo,this.copyDivNo);
            }
        }
    }
</script>

<style scoped>

</style>